import React from 'react'
import { Link } from 'react-router-dom'
import ChevronRightIcon from '../../Component/ChevronRightIcon'

const Breadcrumb = ({breadcrumbs=[],back=null}) => {
  return (
    <div className={`UI-breadcrumb `}>
        {back &&   <Link
              to={back}
              className="UI-breadcrumb-item tw-mr-3 !tw-flex tw-items-center"
            >
             {/* ❮ */}
              <span className='tw-rotate-180'><ChevronRightIcon/></span> Back
            </Link>}
        {breadcrumbs.map((e,i)=>
        i !== breadcrumbs.length-1 && e.path !== null ? 
        <React.Fragment key={i}>
            <Link
              to={e.path}
              className="UI-breadcrumb-item hover:tw-underline hover:tw-underline-offset-4"
            >
              {e.name}
            </Link>
            {/* <i class="fa fa-angle-right"></i> */}
            <ChevronRightIcon/>
            </React.Fragment>
            :
            <React.Fragment key={i}>
            <div
              className="UI-breadcrumb-active"
            >
              {e.name}
            </div>
            </React.Fragment>
            
            )}

            {/* <Link to="/users" className={`UI-breadcrumb-item`}>Users</Link>
            <span>/</span>
            <span className="UI-breadcrumb-item UI-breadcrumb-active">
            {this.state.name}
            </span> */}
        </div>
  )
}

export default Breadcrumb